import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './CustomerChoiceCompany.css';
import RadioButton from '../common/radioButton/RadioButton';
import RegulationAcceptance from '../regulationAcceptance/RegulationAcceptance';
import { useNavigate } from "react-router-dom";
import { getCustomer, setCustomerType } from "../../features/customer/customerSlice";
import { setComplaintType, setCreatedDate, setIsTermOfUseAccepted } from '../../features/complaint/ComplaintSlice';
import { getComplaint, setSelectClient, setSelectComplaintType } from "../../features/complaintTypes/ComplaintTypesSlice";   
import { setCompanyType } from '../../features/customer/companySlice';
import moment from 'moment';
import Modal from '../common/modal/Modal';
import { Dialog } from '../common/dialog/Dialog';

export const CustomerChoiceCompany = ({ isChoiceSelected, onChoiceCompanySelected, isChoiceCompanySelected }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const complaintTypes = useSelector((state) => state.complaintTypes.complaintTypes);
    const [selectedOption, setSelectedOption] = useState(null);
    const isTermOfUseAccepted = useSelector((state) => state.complaint.isTermOfUseAccepted);
    const selectedClient = useSelector((state) => state.complaintTypes.selectedClient);
    const companyType = useSelector((state) => state.customer.type[0]);
    const transportDamage = useSelector((state) => state.complaint.complaintType.name);
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    useEffect(() => {
        dispatch(getComplaint());
        dispatch(getCustomer());
    }, [dispatch]);

    useEffect(() => {
        if (transportDamage === "TransportDamage") setIsDialogOpen(true);
    }, [transportDamage]);

    const closeDialog = () => setIsDialogOpen(false);

    const handleOptionClick = async (option) => {
        dispatch(getComplaint(option.name));
        setSelectedOption(option.displayName);
        setSelectClient(selectedClient);
        dispatch(setComplaintType({
            id: option.id,
            name: option.complaintType,
            displayName: option.displayName
        }));

        if (companyType) {
            dispatch(setCompanyType({
                id: companyType.customerId,
                displayName: companyType.displayName,
                customerType: companyType.customerType,
                description: companyType.description,
                value: companyType.name
            }));
        }

        if (!isChoiceCompanySelected) onChoiceCompanySelected("CustomerChoiceCompany");

        dispatch(setCreatedDate(moment()));
    };

    const validateForm = () => {
        if (isTermOfUseAccepted && selectedOption) navigate('/companySearch');
    };

    return (
        <div className="card" onClick={(e) => e.stopPropagation()}>
            <div className="card-header">
                <h5>firma</h5>
                <p>(<span style={{ color: "#EE2427" }}>Partner Handlowy firmy PRO Sp. z o.o.</span><br />lub osoba prowadząca działalność gospodarczą)</p>
            </div>

            <p className="section-title">Możesz zgłosić:</p>

            <Dialog isOpen={isDialogOpen} onClose={closeDialog} hideCloseButton={true}>
                <h4 style={{ textAlign: 'center', fontFamily: 'Montserrat' }}>Procedura postępowania w przypadku zgłoszenia uszkodzenia transportowego</h4>
                <ol style={{ fontFamily: 'Montserrat' }}>
                    <li>Zgłoszenie elektroniczne przez Partnera Handlowego uszkodzenia transportowego musi zawierać:
                        <ul style={{ listStyle: 'none' }}> 
                            <li>- protokół szkody spisany w obecności kuriera</li>
                            <li>- dokumentację zdjęciową przesyłki i towarów uszkodzonych</li>
                        </ul>
                    </li>
                    <li>Jeżeli w/w warunki nie zostaną spełnione zgłoszenie nie zostanie przyjęte</li>
                    <li>Partner Handlowy proszony o ew. zabezpieczenie nagrań z monitoringu</li>
                </ol>
                <button className="dialog-confirm-btn" onClick={closeDialog}>Zapoznałem/am się</button>
            </Dialog>

            <div className="option-list">
                {Object.values(complaintTypes)
                    .filter(customer => customer.customerId === 2)
                    .flatMap(customer =>
                        customer.complaintTypes.map(option => (
                            <div className="option-row" key={option.id} onClick={() => handleOptionClick(option)}>
                                <RadioButton
                                    id={option.id}
                                    name={option.name}
                                    value={option.displayName}
                                    checked={selectedOption === option.displayName && !isChoiceSelected}
                                />
                                <span className="option-label">{option.displayName}</span>
                            </div>
                        ))
                    )}
            </div>

            {selectedOption && !isChoiceSelected &&
                <div className="form-footer">
                    <RegulationAcceptance
                        checked={isTermOfUseAccepted}
                        selectedOption={selectedOption}
                        complaintTypes={complaintTypes}
                        selectedClient={selectedClient}
                    />
                     <button 
                        className="btn btn-secondary" 
                        type="button" 
                        onClick={validateForm}
                        >
                        Dodaj zgłoszenie
                        </button>
                </div>
            }
        </div>
    );
};